export default __webpack_public_path__ + "static/deco-pole-57bfe8afd2a8255420b8f7ec6e542e55.jpg";